import cx from 'classnames'
import Styles from './Stepper.module.scss'
import { StepProps } from './Types'
import { Check2 } from 'blaze-ui/icons'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'
import { Pressable } from '@react-aria/interactions'
import { useEffect, useRef } from 'react'

export const Step = ({ completed, active, position, children, ...pressProps }: StepProps) => {
  const isDisabled = !completed
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (active && ref.current) {
      ref.current.scrollIntoView({ inline: 'center', block: 'end', behavior: 'smooth' })
    }
  }, [active])

  if (!children) return null

  return (
    <div ref={ref} className={cx(Styles.stepContainer, { [Styles.pressable]: !isDisabled })}>
      <Pressable isDisabled={isDisabled} ref={ref} {...pressProps}>
        <div
          className={cx(Styles.step, {
            [Styles.active]: active,
            [Styles.completed]: completed,
          })}
        >
          <span className={Styles.badge}>
            {completed && <Check2 size={16} />}
            {!completed && position && <span className={Styles.badgeNumber}>{position}</span>}
          </span>
          {!!children.length && <span className={Styles.stepLabel}>{children}</span>}
        </div>
      </Pressable>
      {!!active && (
        <ResponsiveDesign.Mobile>
          <svg
            className={Styles.activeIndicator}
            width="32"
            height="7"
            viewBox="0 0 32 7"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.8555 1.90485C13.7438 0.243858 16.572 0.24386 18.4603 1.90485L20.004 3.26278C22.7422 5.67142 26.2642 7 29.9111 7H32H0H0.404728C4.05159 7 7.57354 5.67142 10.3118 3.26277L10.6105 3L11.8555 1.90485Z"
              fill="var(--default-bg)"
            />
          </svg>
        </ResponsiveDesign.Mobile>
      )}
    </div>
  )
}
